import { render, staticRenderFns } from "./WizardModalSendNotification.vue?vue&type=template&id=f546b856&scoped=true&"
import script from "./WizardModalSendNotification.vue?vue&type=script&lang=js&"
export * from "./WizardModalSendNotification.vue?vue&type=script&lang=js&"
import style0 from "./WizardModalSendNotification.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WizardModalSendNotification.vue?vue&type=style&index=1&id=f546b856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f546b856",
  null
  
)

export default component.exports